import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/myimage.png'


const _withScopeId = n => (_pushScopeId("data-v-051631c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"my-info\" data-v-051631c0><h2 class=\"my-info-title\" data-v-051631c0>■自己紹介■</h2><div class=\"my-info-introduction\" data-v-051631c0><img src=\"" + _imports_0 + "\" width=\"200\" height=\"200\" data-v-051631c0><ul data-v-051631c0><li data-v-051631c0>名前: 綱木泰史(つなきやすふみ)</li><li data-v-051631c0>出身: 九州 熊本県</li><li data-v-051631c0>職業: IT関係(一応、技術職です)</li><li data-v-051631c0>生年月日: 1993年10月23日</li><li data-v-051631c0>趣味: 寺社仏閣・温泉巡り、一人旅</li><li data-v-051631c0>好物: じゃじゃ麺</li><li data-v-051631c0>座右の銘: 七転八起</li><li data-v-051631c0>その他: 運動しないと…</li></ul></div></div><div class=\"about\" data-v-051631c0><h2 class=\"about-title\" data-v-051631c0>■このサイトについて■</h2><pre data-v-051631c0>    ITに関することだったり、趣味に関することだったりを\n    管理者が自由気ままにこのサイトに載せていきます。\n    ゆくゆくはブログを載せたり、個人制作物を紹介したいと思ってますので、\n    見ていただけますとすごく嬉しい限りです。\n    少しでも楽しめる・タメになる情報を発信できるよう努力してまいります。\n  </pre></div>", 2)
const _hoisted_3 = { class: "own-product" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "own-product-title" }, "■個人成果物■", -1))
const _hoisted_5 = { class: "product-list-item" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, (product) => {
          return (_openBlock(), _createElementBlock("div", { key: product }, [
            _createVNode(_component_router_link, { to: "/up-camera-product" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_5, _toDisplayString(product), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      (_ctx.items == [])
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Coming Soon..."))
        : _createCommentVNode("", true)
    ])
  ], 64))
}